import { createTheme } from "@mantine/core";

export const globalTheme = createTheme({
  primaryColor: "vinci",
  colors: {
    vinci: [
      "#fff5e6",
      "#f4e9d8",
      "#e3d1b6",
      "#d3b890",
      "#c4a270",
      "#bc955c",
      "#b88e4f",
      "#a27a3f",
      "#906c36",
      "#7e5d28",
    ],
  },
  components: {
    LoadingOverlay: {
      defaultProps: {
        style: {
          position: "fixed",
          inset: 0,
          height: "100dvh",
        },
      },
    },
    Select: {
      defaultProps: {
        size: "md",
      },
    },
    Input: {
      styles: {
        input: {
          borderRadius: 8,
          height: 56,
          border: "1px solid #D6D1CA33",
          background: "#FFFFFF",
          color: "#000000",
          fontSize: 16,
        },
      },
    },
    InputWrapper: {
      styles: {
        error: {
          color: "#ff3c3c",
        },
        label: {
          color: "#000000",
          fontSize: 16,
          marginBottom: 12,
        },
      },
    },
    Modal: {
      defaultProps: {
        size: "lg",
        radius: 8,
        closeOnEscape: false,
        closeOnClickOutside: false,
        styles: {
          body: {
            marginTop: 10,
          },
        },
      },
    },
  },
});
